import { render, staticRenderFns } from "./CrudCertificationDetails.vue?vue&type=template&id=149f7d44&scoped=true"
import script from "./CrudCertificationDetails.vue?vue&type=script&lang=ts"
export * from "./CrudCertificationDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudCertificationDetails.vue?vue&type=style&index=0&id=149f7d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149f7d44",
  null
  
)

export default component.exports